const options = {
  5: "bg-sky-400/5",
  10: "bg-sky-400/10",
  25: "bg-sky-400/25",
  50: "bg-sky-400/50",
  75: "bg-sky-400/75",
  90: "bg-sky-400/90",
  100: "bg-sky-400",
};

const from = {
  5: "from-sky-400/5",
  10: "from-sky-400/10",
  25: "from-sky-400/25",
  50: "from-sky-400/50",
  75: "from-sky-400/75",
  90: "from-sky-400/90",
  100: "from-sky-400",
};

export default function getBackgroundSky400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
